import { combineReducers } from 'redux';
import storage from 'redux-persist/lib/storage';

// Import individual reducer files
import ui from './uiReducer';
import units from './unitReducers';
import users from './userReducers';
import multilingual from './languagesReducer';
import messages from './messagesReducer';
import { CURRENT_USER_LOGOUT } from '../actions/currentUserActions';
import auth from './authReducer';
import currentUser from './currentUserReducer';
import devices from './devicesReducer';
import system from './systemReducer';
import reports from './reportsReducer';
import temp from './tempReducer';
import assignDevices from './assignDevicesReducer';
import docCategoryReducer from './docCategoryReducer';

// Combine individual reducers into master root reducer
const rootReducer = combineReducers({
  ui,
  units,
  multilingual,
  users,
  messages,
  auth,
  currentUser,
  devices,
  system,
  reports,
  temp,
  assignDevices,
  docCategoryReducer,
});

// This is for clearing out the store when a user logs out of the system and will be used when auth is functioning
const appReducer = (state, action) => {
  if (action.type === CURRENT_USER_LOGOUT) {
    Object.keys(state).forEach((key) => {
      storage.removeItem(`persist:${key}`);
    });
    state = undefined;
    // const history = action.payload;
    // let url = "/logout";
    // history.push(url);
  }
  return rootReducer(state, action);
};

export default appReducer;
